import { jsx } from "panel";
import { SelectTheme } from "common/components/select/constants";
import { SelectEl } from "common/components/select";
import { ButtonSize } from "common/components/button/constants";
export function template() {
  const sections = this.attr(`sections`);
  const emptyEl = /* @__PURE__ */ jsx("div", {
    sel: ".single-option"
  }, ` ${this.attr(`empty-label`)}`);
  const sectionsWithItems = [...sections].filter((section) => {
    var _a;
    return ((_a = section.items) == null ? void 0 : _a.length) > 0;
  });
  if (sectionsWithItems.length === 0) {
    return emptyEl;
  } else if (sectionsWithItems.length === 1) {
    const section = sectionsWithItems[0];
    const [, ...restOptions] = section.items;
    if (restOptions.length < 2) {
      return emptyEl;
    }
  }
  return /* @__PURE__ */ jsx(SelectEl, {
    attrs: {
      elref: `filterSelection`,
      "always-show-caret": true,
      theme: SelectTheme.MenuFilter,
      size: ButtonSize.Inline,
      sections: this.attr(`sections`),
      "menu-width": null
    },
    on: { change: this.filterChangeHandler }
  });
}
